<template>
  <div>
    <Modal @closeDialog="visible = false" :visible="visible" :errorMessage="errorMessage"></Modal>
    <p class="descriptions">
      <span v-if="showDescriptions">{{ colDescription }}</span>
    </p>
    <hot-table :data="hotdata" :settings="settings" ref="hot"></hot-table>
   </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";
import validator from "../../node_modules/@bp_api4/schema_validation/index.js";
import { getTableConfigs } from '../mixins/schemaCache';
import Modal from "./shared/Modal";
import { registerAllModules } from 'handsontable/registry';
registerAllModules();

export default {
  name: "UserHandsOnTable",
  components: {
    HotTable,
    Modal
  },
  props: ["hotdata", "table", "columns"],
  watch: {
    hotdata(newData) {
      this.$refs.hot.hotInstance.loadData(newData);
    }
  },
  methods: {
    parseFrontendError(validate) {
      let errorId = Number(Object.keys(validate.errors));
      let errCol = Object.keys(validate.errors[errorId]).toString();
      let errMsg = validate.errors[errorId][errCol].toString();
      return `Id: ${errorId} - ${errMsg}`;
    }

    // parseBackendError(response) {
    //     let errorId = Number(Object.keys(response.data[0]));
    //     let errCol = Object.keys(response.data[0][errorId]).toString();
    //     let errMsg = response.data[0][errorId][errCol].toString();
    //     return `Id: ${errorId} - ${errMsg}`;
    // }
  },

  data: function() {
    return {
      settings: {
        preventOverflow: "horizontal",
        filters: true,
        comments: true,
        licenseKey: "non-commercial-and-evaluation",
        manualRowMove: true,
        manualColumnMove: true,
        exportFile: true,
        manualRowResize: true,
        manualColumnResize: true,
        autoRowSize: true,
        manualColumnFreeze: true,
        contextMenu: ["freeze_column", "unfreeze_column"],
        height: 600,
        columns: this.columns,
        modifyColWidth: function(width, col) {
          if (width > 300) {
            return 300;
          }
        },
        //cells: function(row, col) {  // Example of using html rendering
        //   let cellMeta = {};
        //   if (col === 3) {
        //     cellMeta.renderer = 'safeHtmlRenderer'
        //   }
        //     return cellMeta;
        // },
        contextMenu: {
          items: {
            Descriptions: {
              name: "Description",
              Description: function(key, selection, clickEvent) {},
              callback: (key, selection, clickEvent) => {
                let test = this.$refs.hot.hotInstance.getCellMeta(selection[0].start.row, selection[0].start.col);
                this.errorMessage = test.__proto__.description;
                if (!this.errorMessage) {
                  this.errorMessage = "No description available";
                }
                this.visible = true;
              }
            }
          }
        },

        afterChange: async changes => {
          // This function is called whenever a cell is touched and then navigated away from.
          if (changes) {
            for await (const change of changes) {
              if (change == null || change[1] === "columnselected" || change[1] === "id") {
                // The function also fires when the table first loads and returns null, check null and kill function.
                continue;
              } else if (
                isNaN(Number(this.$refs.hot.hotInstance.getSourceDataAtRow(change[0]).id)) ||
                !this.$refs.hot.hotInstance.getSourceDataAtRow(change[0]).id
              ) {
                return;
              } else {
                let id = Number(this.$refs.hot.hotInstance.getSourceDataAtRow(change[0]).id); // Get row ID and convert to number
                let columnName = change[1]; // Get column name of changed value
                let currentValue = change[2]; // Value of cell before change
                let updatedValue = change[3].trim(); // Value of cell after change
                this.clearErrorValue(this.$refs.hot.hotInstance.toVisualRow(change[0]), this.$refs.hot.hotInstance.propToCol(change[1]));
                /* TODO:
                          - Check if empty cells have weird behavior
                        */
                // make booleans - boolean instead of string

                if ((updatedValue === "true" || updatedValue === "false" || !isNaN(updatedValue)) && updatedValue.length > 0) {
                    updatedValue =  JSON.parse(updatedValue);
                }

                if (updatedValue.length === 0 ){
                    updatedValue =  null;
                }

                if (currentValue === updatedValue) {
                  //console.log("Value Did Not Change");
                  return;
                } else {
                  // Create Payload
                  let dataObject = {};
                  dataObject.id = id;
                  dataObject[columnName] = updatedValue;

                  let payload = {
                    data: [dataObject],
                    table: this.$props.table  === "users" ? "users_view" : this.$props.table
                  };
                  // Validate on the front end
                  const tableConfigs = await getTableConfigs([payload.table]);
                  const validationSchema = { data: { api4Tables: { tables: Object.values(tableConfigs) } } };
                  let validate = await validator.validateUserPayload(payload, validationSchema, "PATCH");

                  // Parse error, show warning modal
                  if (validate && Object.entries(validate.errors).length !== 0) {
                    let message = this.parseFrontendError(validate);
                    this.updateErrorValue(
                      this.$refs.hot.hotInstance.toVisualRow(change[0]),
                      this.$refs.hot.hotInstance.propToCol(change[1]),
                      message
                    );
                    continue;
                  } else {
                    // If no frontend errors, hit API, update DB
					let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
			  	  	headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users`;

                    let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize` , {
                      method: "PATCH",
                      headers: headers,
					  credentials: 'include',
                      body: JSON.stringify(payload)
                    });

					if ( response.status == 403 ) {
			  		  response = await response.json();
			  		  alert(response.message);
			  		  window.location.href = '/login';
				  	}
					else {
						response = await response.json();
	                    if (response.success === false) {
	                      this.updateErrorValue(
	                        this.$refs.hot.hotInstance.toVisualRow(change[0]),
	                        this.$refs.hot.hotInstance.propToCol(change[1]),
	                        response.message
	                      );
	                      continue;
	                    }
					}
                  }
                }
              }
            }
          }
        }
      },
      updateErrorValue: (row, column, message) => {
        const commentsPlugin = this.$refs.hot.hotInstance.getPlugin("comments");
        commentsPlugin.setCommentAtCell(row, column, message);
        this.$refs.hot.hotInstance.setCellMeta(row, column, "valid", false);
        this.$refs.hot.hotInstance.render();
      },

      clearErrorValue: (row, column) => {
        const commentsPlugin = this.$refs.hot.hotInstance.getPlugin("comments");
        commentsPlugin.removeCommentAtCell(row, column);
        this.$refs.hot.hotInstance.setCellMeta(row, column, "valid", true);
        this.$refs.hot.hotInstance.render();
      },
      colDescription: null,
      showDescriptions: false,
      visible: false,
      errorMessage: "Error"
    };
  }
};

// https://handsontable.com/docs/7.1.0/demo-custom-renderers.html
Handsontable.renderers.registerRenderer("safeHtmlRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  var escaped = Handsontable.helper.stringify(value);
  //escaped = strip_tags(escaped, '<em><b><strong><a><big>'); //be sure you only allow certain HTML tags to avoid XSS threats (you should also remove unwanted HTML attributes)
  td.innerHTML = escaped;

  return td;

  Handsontable.renderers.getRenderer("safeHtmlRenderer").apply(this, arguments);
});
</script>

<style src="../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>
.descriptions {
  text-align: left;
}
</style>
